import { render } from "./orgtable.vue?vue&type=template&id=737c9878"
import script from "./orgtable.vue?vue&type=script&lang=js"
export * from "./orgtable.vue?vue&type=script&lang=js"

import "./orgtable.vue?vue&type=style&index=0&id=737c9878&lang=css"

import exportComponent from "/home/salah/dev/yoda-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__